import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import DefaultLayout from '../Layout/DefaultLayout.jsx';

import './Landing.scss';

export default class Landing extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    helmet: PropTypes.object.isRequired,
  };

  static defaultProps = {
    className: '',
    helmet: {title: '', description: ''},
  }

  render() {
    const { showSidebarMenu, className, helmet } = this.props

    return (
      <DefaultLayout showSidebarMenu={showSidebarMenu ? showSidebarMenu : false} className={`landing ${className}`} helmet={helmet}>
        {this.props.children}
      </DefaultLayout>
    );
  }
}
